import { ValidatorFn , UntypedFormGroup, ValidationErrors } from "@angular/forms";
 // <reference types="node" />
  export const abaValidator: ValidatorFn = (c: UntypedFormGroup): ValidationErrors | null => { 

    let validator = require("bank-routing-number-validator");

    return (c.value != null && c.value.length > 8  && !validator.ABARoutingNumberIsValid(c.value) ) ? { 'valid': false }   :  null;
  };
 
